// @ts-nocheck
import * as Types from '../../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type TakeoffsUsageModalQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type TakeoffsUsageModalQuery = { __typename?: 'Query', materialVariant: { __typename?: 'MaterialVariant', id: string, projectUsages: Array<
      | { __typename?: 'StandaloneProject', id: string, displayName: string, blueprintUrl: { __typename?: 'Url', path: string } }
      | { __typename?: 'Region', id: string, displayName: string, blueprintUrl: { __typename?: 'Url', path: string } }
      | { __typename?: 'Market', id: string, displayName: string, blueprintUrl: { __typename?: 'Url', path: string } }
      | { __typename?: 'Community', id: string, displayName: string, blueprintUrl: { __typename?: 'Url', path: string } }
      | { __typename?: 'Subdivision', id: string, displayName: string, blueprintUrl: { __typename?: 'Url', path: string } }
      | { __typename?: 'Lot', id: string, displayName: string, blueprintUrl: { __typename?: 'Url', path: string } }
      | { __typename?: 'Structure', id: string, displayName: string, blueprintUrl: { __typename?: 'Url', path: string } }
      | { __typename?: 'Unit', id: string, displayName: string, blueprintUrl: { __typename?: 'Url', path: string } }
    >, takeoffUsages: Array<
      | { __typename?: 'ReadyPlan', id: string, name: string, displayName: string, updatedAt: Types.Scalars['DateTime']['input'], owner?: { __typename?: 'InternalUser', id: string, name: string } | null | undefined }
      | { __typename?: 'PlanPackage', id: string, name: string, displayName: string, updatedAt: Types.Scalars['DateTime']['input'], owner?: { __typename?: 'InternalUser', id: string, name: string } | null | undefined, aggregateLatest: { __typename?: 'ReadyPlanAggregateVersion', id: string } }
      | { __typename?: 'DesignPackage', id: string, name: string, displayName: string, updatedAt: Types.Scalars['DateTime']['input'], owner?: { __typename?: 'InternalUser', id: string, name: string } | null | undefined, blueprintUrl: { __typename?: 'Url', path: string } }
      | { __typename?: 'ProductOffering', id: string, name: string, displayName: string, updatedAt: Types.Scalars['DateTime']['input'], owner?: { __typename?: 'InternalUser', id: string, name: string } | null | undefined, blueprintUrl: { __typename?: 'Url', path: string } }
    > } };


export const TakeoffsUsageModalDocument = gql`
    query TakeoffsUsageModal($id: ID!) {
  materialVariant(id: $id) {
    id
    projectUsages {
      id
      displayName
      blueprintUrl {
        path
      }
    }
    takeoffUsages {
      id
      name
      displayName
      updatedAt
      ... on ReadyPlan {
        id
        owner {
          id
          name
        }
      }
      ... on PlanPackage {
        id
        owner {
          id
          name
        }
        aggregateLatest {
          id
        }
      }
      ... on DesignPackage {
        id
        owner {
          id
          name
        }
        blueprintUrl {
          path
        }
      }
      ... on ProductOffering {
        id
        owner {
          id
          name
        }
        blueprintUrl {
          path
        }
      }
    }
  }
}
    `;

/**
 * __useTakeoffsUsageModalQuery__
 *
 * To run a query within a React component, call `useTakeoffsUsageModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useTakeoffsUsageModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTakeoffsUsageModalQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTakeoffsUsageModalQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TakeoffsUsageModalQuery, TakeoffsUsageModalQueryVariables> & ({ variables: TakeoffsUsageModalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TakeoffsUsageModalQuery, TakeoffsUsageModalQueryVariables>(TakeoffsUsageModalDocument, options);
      }
export function useTakeoffsUsageModalLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TakeoffsUsageModalQuery, TakeoffsUsageModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TakeoffsUsageModalQuery, TakeoffsUsageModalQueryVariables>(TakeoffsUsageModalDocument, options);
        }
// @ts-ignore
export function useTakeoffsUsageModalSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<TakeoffsUsageModalQuery, TakeoffsUsageModalQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TakeoffsUsageModalQuery, TakeoffsUsageModalQueryVariables>;
export function useTakeoffsUsageModalSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TakeoffsUsageModalQuery, TakeoffsUsageModalQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TakeoffsUsageModalQuery | undefined, TakeoffsUsageModalQueryVariables>;
export function useTakeoffsUsageModalSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TakeoffsUsageModalQuery, TakeoffsUsageModalQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TakeoffsUsageModalQuery, TakeoffsUsageModalQueryVariables>(TakeoffsUsageModalDocument, options);
        }
export type TakeoffsUsageModalQueryHookResult = ReturnType<typeof useTakeoffsUsageModalQuery>;
export type TakeoffsUsageModalLazyQueryHookResult = ReturnType<typeof useTakeoffsUsageModalLazyQuery>;
export type TakeoffsUsageModalSuspenseQueryHookResult = ReturnType<typeof useTakeoffsUsageModalSuspenseQuery>;
export type TakeoffsUsageModalQueryResult = ApolloReactCommon.QueryResult<TakeoffsUsageModalQuery, TakeoffsUsageModalQueryVariables>;